export const STEP_CARD_WIDTH = 220;
export const STEP_CARD_MAX_HEIGHT = 139; // Measured with two lines of text and open panel
export const HISTORY_STEP_CARD_MAX_HEIGHT = STEP_CARD_MAX_HEIGHT + 2 * 3 * 18; // up to 3 panels
export const PANEL_HEIGHT = 18;
